export const redirectFBReferrals = () => {
  const trackedParam = 'fbclid';
  if (typeof window !== 'undefined') {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    urlParams.get(trackedParam);

    // if (trackedParamValue) {
    //   window.location.href = `https://orders.na.chilipiper.com/router/facebook-ads?${trackedParam}=${trackedParamValue}&oco_souce=wr`;
    // }

    //console.log(trackedParam); // will output CODE_FROM_REDIRECT_ON_SERVERSIDE
  };
};


export const formatPrice = (value, options = {}) => {
  const {
    currency = '',       // e.g. '$', '€', '₽'
    decimals = 0,        // number of decimal places
    locale = 'en-US'     // formatting locale
  } = options;

  return currency + Number(value)
    .toLocaleString(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
}

export const getLoginUrl = () => {
  if (typeof window !== 'undefined') {
    const currentDomain = window.location.hostname;
    return `https://partners.${currentDomain}/login`;
  }
  // Fallback for SSR or when window is not available
  return 'https://partners.tryorders.co/login';
}